"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sanjiang = require("@/api/sanjiang");
var _static = require("../static");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SjOilOrderDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      lastOrderId: '',
      // 记录上次获取详情的订单ID，避免重复调用
      orderDetail: {},
      productList: [],
      // 交易状态选项
      transactionStatusOptions: _static.offsetStateOption,
      // 福豆弹框相关
      fudouDialogVisible: false,
      fudouRecordList: [],
      fudouPage: 1,
      fudouPageSize: 10,
      fudouTotal: 0,
      // 优惠记录弹框相关
      discountDialogVisible: false
    };
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal && this.orderId) {
        this.getOrderDetail();
      }
    }
  },
  methods: {
    // 获取订单详情
    getOrderDetail: function () {
      var _getOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.orderId) {
                _context.n = 1;
                break;
              }
              this.$message.warning('订单号不能为空');
              return _context.a(2);
            case 1:
              if (!(this.lastOrderId === this.orderId && this.orderDetail.orderNo)) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              this.loading = true;
              _context.p = 3;
              _context.n = 4;
              return (0, _sanjiang.getStationOrderDetail)(this.orderId);
            case 4:
              response = _context.v;
              if (!(!response || _typeof(response) !== 'object' || Array.isArray(response))) {
                _context.n = 5;
                break;
              }
              throw new Error('订单详情数据为空或格式不正确');
            case 5:
              // 处理商品列表数据 - 将 stationOrder 转换为数组
              if (response.stationOrder) {
                // 如果 stationOrder 是对象，转换为数组
                if (Array.isArray(response.stationOrder)) {
                  this.productList = response.stationOrder;
                } else if (_typeof(response.stationOrder) === 'object') {
                  // 如果是对象，将其包装成数组
                  this.productList = [response.stationOrder];
                } else {
                  this.productList = [];
                }
              } else if (response.productList) {
                this.productList = response.productList;
              } else {
                this.productList = [];
              }
              // 模板按数组读取第三方订单，避免对象或空数组导致渲染报错、loading 遮罩无法更新。
              this.orderDetail = _objectSpread(_objectSpread({}, response), {}, {
                stationOrder: this.productList
              });
              this.lastOrderId = this.orderId;
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              this.$message.error('获取订单详情失败');
              console.error('获取订单详情失败:', _t);

              // 如果接口调用失败，可以回退到模拟数据用于调试
              // await this.mockGetOrderDetail(this.orderId)
            case 7:
              _context.p = 7;
              this.loading = false;
              return _context.f(7);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[3, 6, 7, 8]]);
      }));
      function getOrderDetail() {
        return _getOrderDetail.apply(this, arguments);
      }
      return getOrderDetail;
    }(),
    // 查看福豆
    viewFudou: function viewFudou() {
      this.fudouDialogVisible = true;
      this.getFudouRecordList();
    },
    // 获取福豆使用记录列表
    getFudouRecordList: function () {
      var _getFudouRecordList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.orderDetail.orderNo) {
                _context2.n = 1;
                break;
              }
              this.$message.warning('订单号不能为空');
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return (0, _sanjiang.getIntegralLog)(this.orderDetail.orderNo);
            case 2:
              response = _context2.v;
              // 根据实际返回的数据结构调整
              if (Array.isArray(response)) {
                this.fudouRecordList = response;
                this.fudouTotal = response.length;
              } else if (response && response.list) {
                this.fudouRecordList = response.list;
                this.fudouTotal = response.total || response.list.length;
              } else if (response && response.data) {
                this.fudouRecordList = response.data;
                this.fudouTotal = response.data.length;
              } else {
                this.fudouRecordList = [];
                this.fudouTotal = 0;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.$message.error('获取福豆使用记录失败');
              console.error('获取福豆使用记录失败:', _t2);
              this.fudouRecordList = [];
              this.fudouTotal = 0;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getFudouRecordList() {
        return _getFudouRecordList.apply(this, arguments);
      }
      return getFudouRecordList;
    }(),
    // 福豆记录分页 - 每页条数变化
    handleFudouSizeChange: function handleFudouSizeChange(val) {
      this.fudouPageSize = val;
      this.fudouPage = 1;
      this.getFudouRecordList();
    },
    // 福豆记录分页 - 当前页变化
    handleFudouCurrentChange: function handleFudouCurrentChange(val) {
      this.fudouPage = val;
      this.getFudouRecordList();
    },
    // 查看优惠记录
    viewDiscountRecord: function viewDiscountRecord() {
      this.discountDialogVisible = true;
    },
    // 关闭弹框
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    // 获取状态类型
    getStatusType: function getStatusType(status) {
      var statusMap = {
        0: 'info',
        // 已取消
        1: 'primary',
        // 待支付
        2: 'success',
        // 已支付
        6: 'success',
        // 已完结
        7: 'warning',
        // 退款中
        8: 'danger',
        // 退款成功
        14: 'danger' // 部分退款
      };
      return statusMap[status] || 'info';
    },
    // 获取状态标签
    getStatusLabel: function getStatusLabel(status) {
      var statusOption = this.transactionStatusOptions.find(function (item) {
        return item.value === status;
      });
      return statusOption ? statusOption.label : '未知状态';
    },
    // 获取福豆交易类型文字
    getTransactionTypeText: function getTransactionTypeText(type) {
      var typeMap = {
        1: '发放',
        2: '回收',
        3: '使用',
        4: '过期',
        5: '退回'
      };
      return typeMap[type] || '未知';
    },
    // 获取福豆交易类型标签颜色
    getTransactionTypeTag: function getTransactionTypeTag(type) {
      var tagMap = {
        1: 'success',
        // 发放 - 绿色
        2: 'danger',
        // 回收 - 红色
        3: 'warning',
        // 使用 - 橙色
        4: 'info',
        // 过期 - 灰色
        5: 'primary' // 退回 - 蓝色
      };
      return tagMap[type] || 'info';
    },
    // 获取福豆交易类型图标
    getTransactionTypeIcon: function getTransactionTypeIcon(type) {
      var iconMap = {
        1: 'el-icon-plus',
        // 发放
        2: 'el-icon-minus',
        // 回收
        3: 'el-icon-shopping-cart-2',
        // 使用
        4: 'el-icon-time',
        // 过期
        5: 'el-icon-refresh-left' // 退回
      };
      return iconMap[type] || 'el-icon-info';
    }
  }
};